module.exports = __webpack_public_path__ + "static/media/fire.a92572f2.svg";